import DoneIcon from 'assets/ver2/icons/done-small-icon.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import { DESKTOP_MIN_WIDTH, TABLET_MAX_WIDTH } from 'constants';
import useCommonStore from 'hooks/useCommonStore';
import useCountdownToActionVer2 from 'hooks/useCountdownToActionVer2';
import useLang from 'hooks/useLang';
import { delay, isFunction } from 'lodash';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexColCenterCenterMixinObject,
  paragraph500Mixin,
} from 'styles';

const DeletePaytoAccountAgreementPopup = ({
  isOpen,
  imageSrc,
  imagesStyles = {},
  text,
  content,
  alignContent = 'left' || 'center' || 'right',
  buttonLabel1,
  buttonLabel2,
  onClose,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  isClickBackdropToClose = false,
}) => {
  const { t } = useLang();

  const isShowCloseButton = buttonLabel1 && isFunction(onClose);

  const { setLoading } = useCommonStore();

  const [isSuccess, setSuccess] = useState(false);

  const handleDeleteCountdown = () => {
    setLoading(false);
    setSuccess(false);
  };
  useCountdownToActionVer2({
    countdownInit: 5,
    isRun: isSuccess,
    deps: [isSuccess],
    cb: handleDeleteCountdown,
  });

  const renderModalBody = () => {
    if (isSuccess)
      return (
        <SuccessBody>
          <img src={DoneIcon} width={75} height={60} />
          <p>{t('form_delete_payto_account_success')}</p>
        </SuccessBody>
      );
    return (
      <>
        <ModalBody>
          {imageSrc && (
            <>
              <ImageWrap>
                <img
                  src={imageSrc}
                  alt=""
                  width={50}
                  height={50}
                  style={imagesStyles}
                />
              </ImageWrap>
              <SizeBox height={10} />
            </>
          )}
          {text && <Text dangerouslySetInnerHTML={{ __html: text }} />}
          {content && (
            <SubText
              $alignContent={alignContent}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </ModalBody>
        <ModalFooter
          style={{
            justifyContent: !buttonLabel1 && 'center',
          }}
        >
          {isShowCloseButton && (
            <ButtonCommon
              value={buttonLabel1}
              onClick={onClose}
              styles={{
                margin: '0px',
                width: '50%',
              }}
              color="var(--ds-c-blue)"
              background="var(--ds-c-white)"
            />
          )}
          <ButtonCommon
            value={buttonLabel2}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
            styles={{
              margin: '0px',
              width: isShowCloseButton ? '50%' : '100%',
            }}
            onClick={() => {
              setLoading(false);
              onClick(() => {
                setSuccess(true);
                delay(onClose, 1000, null);
              });
            }}
            isUseKeyDown
          />
        </ModalFooter>
      </>
    );
  };

  const handleOnClickBackdropToClose = () => {
    if (isClickBackdropToClose) {
      onClose();
    }
  };

  return (
    <>
      <style>
        {zIndexModal
          ? `
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .modal {
              z-index: ${zIndexModal || 1101};
            }
          }
        `
          : ``}

        {isBackdropOverlap
          ? `
          .alert-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .alert-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={handleOnClickBackdropToClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="alert-modal-backdrop"
        centered
      >
        {renderModalBody()}
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 16px;
      border-radius: 12px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      width: 100%;
      height: fit-content;
      margin-inline: auto;
      border: none;
      @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
        width: 436px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  margin-bottom: 24px;
  text-align: left;
`;
const ImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Text = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  color: var(--ds-c-blue);
  margin: 0;
  margin-bottom: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const SubText = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: ${(props) => props.$alignContent};
  white-space: break-spaces;

  color: var(--ds-c-grey-dark);
  margin: 0;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

const SuccessBody = styled.div`
  ${displayFlexColCenterCenterMixinObject};
  gap: 10px;
  & p {
    ${paragraph500Mixin};
  }
`;

export default DeletePaytoAccountAgreementPopup;
